export const DSB_API_EXCEPTION = 1
